// POS-I254: per-line received quantity for the Receive Purchase Order dialog (partial receive).
export interface ReceiveLine {
  id: string;
  orderedQty: number | string;
  receivedQty?: number | string | null;
}

/** Quantity still to be received on a line (never negative). */
export function pendingQty(line: ReceiveLine): number {
  return Math.max(0, Number(line.orderedQty) - Number(line.receivedQty || 0));
}

/** Entered quantity for a line: defaults to the pending quantity, clamped to 0..pending, whole units. */
export function receiveQtyFor(line: ReceiveLine, entered: Record<string, string | undefined>): number {
  const pending = pendingQty(line);
  const raw = entered[line.id];
  if (raw === undefined) return pending;
  const n = Math.floor(Number(raw));
  if (!Number.isFinite(n) || n < 0) return 0;
  return Math.min(n, pending);
}

/** The Posting-stock text: PO number plus supplier when known. */
export function receiveHeading(po: { orderNumber?: string | null; supplier?: { name?: string | null } | null } | null): string {
  if (!po) return '';
  return [po.orderNumber, po.supplier?.name].filter(Boolean).join(' - ');
}
